import React from 'react'
import { LazyComponent } from '@offerzen/pinata-shame'

const MobileWorkHistoryLazy = props => (
  <LazyComponent componentName="workHistoryList" loader={() => import('./MobileWorkHistoryScene')}>
    {MobileWorkHistoryScene => (
      <Choose>
        <When condition={MobileWorkHistoryScene}>
          <MobileWorkHistoryScene {...props} />
        </When>
        <Otherwise>{/* TODO Add skeletons */}</Otherwise>
      </Choose>
    )}
  </LazyComponent>
)

export default MobileWorkHistoryLazy
